import { Icon, type IconName } from '@components/icons/Icon'
import type React from 'react'
import bgVector from '../../assets/figma/116-3974/5dd07467e03e93c25199c9cd58f7b0799f0cf229.svg'

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: IconName
  'aria-label': string
}

export const IconButton: React.FC<IconButtonProps> = ({ icon = 'Back', className, ...rest }) => {
  return (
    <button type="button" className={`relative inline-block size-10 ${className ?? ''}`} {...rest}>
      {/* Background shape from Figma */}
      <img
        src={bgVector}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 block size-10 max-w-none"
      />
      {/* Icon (24x24) positioned per Figma (left-2 top-2) */}
      <div className="absolute left-2 top-2 overflow-clip size-6">
        <Icon content={icon} />
      </div>
    </button>
  )
}

export default IconButton
